import { invoices } from "../../constants/actionTypes";

const INITIAL_STATE = {
  previous_invoices: {},
  previous_invoices_error: {},
  loader: false,
};

const invoicesReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case invoices.SET_INVOICES_LIST_SUCCESS:
      return {
        ...state,
        previous_invoices: action?.payload,
      };
    case invoices.SET_INVOICES_LIST_ERROR:
      return {
        ...state,
        previous_invoices_error: action?.data?.data,
      };

    case invoices.SET_INVOICE_LOADER:
      return {
        ...state,
        loader: action?.data,
      };
    case invoices.GENERATE_INVOICE:
      return {
        ...state,
        loader: true,
      };
    case invoices.SUCCESS_GENERATE_INVOICE:
      return {
        ...state,
        loader: false,
      };
    case invoices.ERROR_GENERATE_INVOICE:
      return {
        ...state,
        loader: false,
      };
    case invoices.UPLOAD_INVOICE_JSON_SUCCESS:
      return state;
    case invoices.UPLOAD_INVOICE_JSON_ERROR:
      return state;
    case invoices.UPDATE_INVOICE_PAYMENT_STATUS:
      return {
        ...state,
        loader: true,
      };
    case invoices.UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        loader: false,
      };
    case invoices.UPDATE_INVOICE_PAYMENT_STATUS_ERROR:
      return {
        ...state,
        loader: false,
      };

    default:
      return state;
  }
};

export default invoicesReducer;
